const TAKE_KEY = "__cirrus_proctorio_takeExamReceived__"

export const getPersistedTake = () => sessionStorage.getItem(TAKE_KEY) === TAKEN_VALUE
export const setPersistedTake = () => sessionStorage.setItem(TAKE_KEY, TAKEN_VALUE)
export const clearPersistedTake = () => sessionStorage.removeItem(TAKE_KEY)

const TAKEN_VALUE = "1"
